import type { IToastConfig } from 'src/common/primitives/Toast';

export function generateDeleteSuccessToast(): IToastConfig {
  return {
    title: `The vehicle has been deleted`,
  };
}
